import { makeStyles } from '@mui/styles'
import {
  MyAccountTheme,
  MyAccountMiniWidgetButtonClasses,
} from '@dxp-module/themes'

const miniWidgetButtonStyles = makeStyles<
  MyAccountTheme,
  Record<string, never>,
  MyAccountMiniWidgetButtonClasses
>(
  ({ palette }) => ({
    root: {
      width: '100%',
      border: `2px solid ${palette.primary.main}`,
    },
    container: {
      display: 'inline-flex',
      alignItems: 'center',
    },
    buttonText: {
      width: '100%',
      border: 'unset',
      fontSize: 'inherit',
      lineHeight: 1.2,
      maxWidth: '100%',
      textAlign: 'inherit',
      textDecoration: 'underline',
      padding: 'unset',
    },
    welcomeMessage: {
      margin: '0 4px',
      color: palette.common.white,
    },
    icon: {
      marginRight: 4,
    },
  }),
  { name: 'MyAccount_MiniWidgetButton' }
)

export default miniWidgetButtonStyles
